<template>
  <div class="card">
    <div class="card-body">
      <loading
        :active.sync="isLoading"
        :is-full-page="false"
        :height="45"
        :width="45"
        color="#398BD7"
      ></loading>
      <div class="row">
        <div class="col-12">
          <h4 class="card-title mb-4 float-sm-left">Total Servis By Kategori</h4>
          <div class="float-sm-right">
            <date-picker
              v-model="dateRange"
              type="date"
              input-class="form-control"
              range
              placeholder="Select date range"
              :format="'YYYY-MM-DD'"
              :shortcuts="shortcuts"
              @input="showChart"
              :clearable="false"
            >
            </date-picker>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <Highcharts :options="chart_series"></Highcharts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_module: "dashboards",
      date: new Date(),
      isLoading: true,
      chart_series: {},
      dateRange: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      ],
      shortcuts: [
        {
          text: "Today",
          onClick() {
            const date = new Date();
            const result = [date, date];
            // return a Date
            return result;
          },
        },
        {
          text: "Yesterday",
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            const result = [date, date];
            // return a Date
            return result;
          },
        },
        {
          text: "Last 7 Days",
          onClick() {
            const date = new Date();
            let last7Day = new Date();
            last7Day.setDate(date.getDate() - 6);
            last7Day.setHours(0, 0, 0, 0);
            const result = [last7Day, date];
            // return a Date
            return result;
          },
        },
        {
          text: "Last 30 Days",
          onClick() {
            const date = new Date();
            let last30Day = new Date();
            last30Day.setDate(date.getDate() - 29);
            last30Day.setHours(0, 0, 0, 0);
            const result = [last30Day, date];
            // return a Date
            return result;
          },
        },
        {
          text: "This Month",
          onClick() {
            const date = new Date();
            const start = new Date(date.getFullYear(), date.getMonth(), 1);
            const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            const result = [start, end];
            // return a Date
            return result;
          },
        },
        {
          text: "Last Month",
          onClick() {
            const date = new Date();
            const start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            const end = new Date(
              date.getFullYear(),
              date.getMonth() - 1 + 1,
              0
            );
            const result = [start, end];
            // return a Date
            return result;
          },
        },
        {
          text: "Next Month",
          onClick() {
            const date = new Date();
            const start = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            const end = new Date(
              date.getFullYear(),
              date.getMonth() + 1 + 1,
              0
            );
            const result = [start, end];
            // return a Date
            return result;
          },
        },
        {
          text: "This Years",
          onClick() {
            const start = new Date(new Date().getFullYear(), 0, 1);
            const end = new Date(new Date().getFullYear(), 11, 31);
            const result = [start, end];
            // return a Date
            return result;
          },
        },
        {
          text: "Last Years",
          onClick() {
            const start = new Date(new Date().getFullYear() - 1, 0, 1);
            const end = new Date(new Date().getFullYear() - 1, 11, 31);
            const result = [start, end];
            // return a Date
            return result;
          },
        },
      ],
    };
  },
  mounted() {
    this.showChart();
  },
  methods: {
    showChart: function () {
      this.isLoading = true;
      let params = {};

      params["date_start"] = this.$moment(this.dateRange[0]).format("YYYY-MM-DD");
      params["date_end"] = this.$moment(this.dateRange[1]).format("YYYY-MM-DD");

      this.axios
        .post("/" + this.table_module + "/total-servis-by-kategori", params)
        .then((response) => {
          this.isLoading = false;
          let series = response.data.data
          this.$nextTick(() => {
            this.chart_series = {
              chart: {
                type: "column",
              },
              title: {
                text: "",
              },
              accessibility: {
                announceNewData: {
                  enabled: true,
                },
              },
              xAxis: {
                type: "category",
              },
              credits: {
                enabled: false,
              },
              yAxis: {
                title: {
                  text: "Total",
                },
              },
              legend: {
                enabled: false,
              },
              plotOptions: {
                series: {
                  borderWidth: 0,
                  dataLabels: {
                    enabled: true,
                    format: "{point.y:,.0f}",
                  },
                  cursor: 'pointer',
                  point: {
                    events: {
                      click: ({point}) => {
                        this.showOverlay = false;
                        alert('Category: ' + point.name + ', value: ' + point.y);
                        var url = "/services_transaction?search[srv_t_cat]="+point.y+"&search[srv_t_date_start]="+params["date_start"]+"&search[srv_t_date_start]="+params["date_end"];
                        window.open(url , '_blank');
                      }
                    }
                  }
                },
              },

              tooltip: {
                headerFormat:
                  '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat:
                  '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> <br/>',
              },

              series: [
                {
                  name: "Kategori",
                  colorByPoint: true,
                  data: series,
                },
              ],
            };
          });
        });
    },
  },
};
</script>